/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import { object } from 'prop-types';
import { compose } from 'recompose';
import ReactMarkdown from 'react-markdown';
import mbpLogger from '@module-logger/mbp';
import { useQuery } from '@apollo/client';
import findContent from '../../../../../gql/queries/findContent';
import { getBrand } from '../../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import PDPLargePromoBlock from './PDPLargePromoBlock';

const PDPLargePromoContainer = ({
    brand,
}) => {
    const FIND_PROMO_QUERY = findContent({
        brand: brand?.domain,
        contentType: 'banner_1up_standard_tall',
    });

    let response = null;

    const { loading, error, data } = useQuery(FIND_PROMO_QUERY);
    if (loading) {
        response = null;
    }
    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            jsError: error,
            message: 'Failed load promo container',
        });
        response = <ReactMarkdown source="There has been an error retrieving details for this promotion. If this issue persists, please contact us." />;
    } else response = <></>;
    const  promoData = data?.findContent?.content?.entries[0];
    if (promoData) {
        response =  <PDPLargePromoBlock  promoData={promoData}  promoStyles={promoData.message.message_background_color} />;
    }
    return response;
};

PDPLargePromoContainer.propTypes = {
    brand: object.isRequired,
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

const enhance = compose(
    connect(mapStateToProps),
);

export default enhance(PDPLargePromoContainer);
